import { apiClient } from '../services/apiService';
import { getCurrentIdToken } from '../services/authentication/authenticationService';
import { API_ROOT } from './constants';

export const uploadTaxonomy = (
  file: File,
  userEmail: string,
  callbackProgress: () => void,
  callbackOk: () => void,
  callbackError: () => void
): Promise<boolean> => {
  callbackProgress();
  var formdata = new FormData();
  formdata.append('files', file);
  formdata.append('worksheetName', 'Taxonomy');
  formdata.append('customer', 'CUSTOMER');
  return new Promise((resolve, reject) => {
    apiClient
      .post(`${API_ROOT}/uploadTaxonomy?email=${userEmail}`, formdata)
      .then((res) => {
        resolve(res.data);
        callbackOk();
      })
      .catch((err) => {
        callbackError();
        console.error(err);
      });
  });
};

export const getTaxonomyTemplate = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const headers = new Headers();
    headers.set('authorization', `Bearer ${getCurrentIdToken()}`);
    fetch(`${API_ROOT}/taxonomyTemplateDownload`, {
      method: 'GET',
      headers: headers,
    })
      .then((res) => {
        resolve(res.blob());
      })
      .catch((err) => {
        console.error(err);
      });
  });
};
